export default __webpack_public_path__ + "static/media/DSC_0540.1b7f44c8.jpg";